import { IonButtons, IonPage } from "@ionic/react";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/button";
import { AuthContent } from "@/components/molecules/auth/content";
import { AuthHeader } from "@/components/molecules/auth/header";
import { Routes } from "@/lib/router";

export function AuthRegisterSuccess() {
  return (
    <IonPage>
      <AuthHeader>
        <IonButtons slot="primary"></IonButtons>
      </AuthHeader>
      <AuthContent>
        <div className="flex flex-col items-center gap-6 text-center">
          <CheckCircle size={64} className="text-green-500" />
          <div className="flex flex-col gap-3">
            <h1 className="text-2xl font-bold">Bedankt voor je registratie!</h1>
            <p className="text-base text-gray-600">
              We hebben je aanvraag ontvangen. Ons team zal je aanmelding handmatig beoordelen en je
              binnen enkele werkdagen contacteren voor de verdere onboarding.
            </p>
            <p className="text-sm text-gray-500">
              Je ontvangt een bevestigingsmail op het door jou opgegeven e-mailadres.
            </p>
          </div>
          <Button
            fill="solid"
            className="w-full"
            routerLink={Routes.AuthSignInPassword()}
            routerDirection="back"
          >
            Terug naar inloggen
          </Button>
        </div>
      </AuthContent>
    </IonPage>
  );
}
